import { gql } from '@apollo/client'

export const GET_TEAM_TAB_DATA = gql`
  query GetTeamTabData($fantasyLeagueId: ID!) {
    currentFantasyLeagueMember(fantasyLeagueId: $fantasyLeagueId) {
      id
      budget
      teamName
      tactics
      fantasyLeague {
        id
        name
      }
      fantasyTeamPlayers {
        id
        createdAt
        startingPosition
        releaseClause
        signedAt
        individuallyProtected
        weeklyWindowProtected
        releaseClausePayable
        player {
          id
          createdAt
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          lastWeekScore
          lastWeekNumber
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
      }
    }
  }
`
